<template>
</template>

<script>

export default {
  name: "ResetEmailPassword",
};
</script>
